/**
 * @generated SignedSource<<820b39fd936bd68f620e7c0cd33662e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GroupCard_group$data = {
  readonly archived: boolean;
  readonly clients: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"StackedClientsAvatars_clients">;
  }>;
  readonly id: string;
  readonly name: string;
  readonly slug: string;
  readonly " $fragmentSpreads": FragmentRefs<"ManageGroupDialog_group">;
  readonly " $fragmentType": "GroupCard_group";
};
export type GroupCard_group$key = {
  readonly " $data"?: GroupCard_group$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupCard_group">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GroupCard_group",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ManageGroupDialog_group"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "clients",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StackedClientsAvatars_clients"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Group",
  "abstractKey": null
};

(node as any).hash = "d6937689282c269351b4e4daf0b6a0a5";

export default node;
